export const EnvelopeIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.168 17.0833H5.83464C3.33464 17.0833 1.66797 15.8333 1.66797 12.9167V7.08332C1.66797 4.16666 3.33464 2.91666 5.83464 2.91666H14.168C16.668 2.91666 18.3346 4.16666 18.3346 7.08332V12.9167C18.3346 15.8333 16.668 17.0833 14.168 17.0833Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1654 7.5L11.557 9.58333C10.6987 10.2667 9.29036 10.2667 8.43203 9.58333L5.83203 7.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
